import React, { useEffect } from "react";
import tokenService from "../api/tokenService";

const useAuthentication = () => {
  const [token, setToken] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  useEffect(() => {
    const getToken = async () => {
      setIsLoading(true);
      setError(null);

      try {
        console.log('%c🔑 useAuthentication: Fetching token...', 'color: #3b82f6; font-weight: bold');
        // Fetch token from local API
        const accessToken = await tokenService.getAccessToken();
        setToken(accessToken);
        console.log('%c✅ useAuthentication: Token acquired successfully', 'color: #10b981; font-weight: bold');
      } catch (err) {
        console.error('%c❌ useAuthentication: Token acquisition error', 'color: #ef4444; font-weight: bold', err);
        setError(err.message || "Failed to acquire token");
        setToken(null);
      } finally {
        setIsLoading(false);
      }
    };

    getToken();

    // Set up interval to check token validity periodically
    const intervalId = setInterval(() => {
      if (!tokenService.isTokenValid()) {
        console.log('%c🔄 useAuthentication: Token expired, fetching new token', 'color: #f59e0b; font-weight: bold');
        getToken();
      }
    }, 60000); // Check every minute

    return () => clearInterval(intervalId);
  }, []);

  return { token, isLoading, error };
};

export default useAuthentication;
